/** Telegram links are rendered directly in the account screen. */
export function normalizeTelegramUsername(value) {
  const username = String(value || '').trim().replace(/^@/, '');
  return /^[a-z][a-z0-9_]{4,31}$/i.test(username) ? username : '';
}

export function telegramBotLink(username, fallback = '') {
  const normalized = normalizeTelegramUsername(username);
  if (normalized) return `https://t.me/${normalized}`;
  try {
    const url = new URL(fallback);
    if (url.protocol !== 'https:' || url.hostname !== 't.me' || url.username || url.password) return '';
    const fallbackUsername = normalizeTelegramUsername(url.pathname.slice(1));
    return fallbackUsername ? `https://t.me/${fallbackUsername}` : '';
  } catch {
    return '';
  }
}

export function telegramProfileLink(value) {
  const link = String(value || '').trim();
  return /^tg:\/\/user\?id=[1-9]\d*$/.test(link) ? link : telegramBotLink('', link);
}

/** Prefer relative TTL so a device clock in another timezone (or skewed) is safe. */
export function telegramCodeExpiry(data, now = Date.now()) {
  const ttl = Number(data?.expires_in_seconds);
  if (Number.isFinite(ttl) && ttl >= 0 && data?.expires_in_seconds != null) {
    return now + ttl * 1000;
  }
  const raw = String(data?.expires_at || '').trim();
  if (raw) {
    const normalized = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/.test(raw)
      ? `${raw.replace(' ', 'T')}Z`
      : raw;
    const expiry = Date.parse(normalized);
    if (Number.isFinite(expiry)) return expiry;
  }
  return now + 10 * 60 * 1000;
}

export function telegramErrorMessage(error, fallback) {
  return error?.response?.data?.error?.message
    || error?.response?.data?.message
    || error?.message
    || fallback;
}
